import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * ScoringExplainer — Inline collapsible "How scores work" section.
 * Placed near the top of screener results and portfolio tables.
 * Concise version that links to the full /how-it-works page.
 */
const ScoringExplainer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="scoring-explainer">
      <button
        className="scoring-explainer-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="scoring-explainer-icon">&#9432;</span>
        <span>How these scores work</span>
        <span className={`scoring-explainer-arrow ${isOpen ? 'open' : ''}`}>&#9660;</span>
      </button>

      {isOpen && (
        <div className="scoring-explainer-content">
          <div className="explainer-grid">
            <div className="explainer-item">
              <strong>Quality (0-100)</strong>
              <span>Fundamentals: growth, margins, ROIC, competitive moat</span>
            </div>
            <div className="explainer-item">
              <strong>Setup (0-100)</strong>
              <span>Technicals: trend, momentum, sector rotation, volume</span>
            </div>
            <div className="explainer-item">
              <strong>Convex (0-5)</strong>
              <span>Asymmetric upside: catalysts, demand signals, valuation gap</span>
            </div>
            <div className="explainer-item">
              <strong>Conviction</strong>
              <span>Weighted blend that adjusts based on market conditions</span>
            </div>
          </div>
          <p className="explainer-note">
            The weighting between Quality and Setup shifts continuously with market conditions — Quality dominates in stressed markets, Setup leads in momentum-driven markets. Scores also factor in sector performance and market turbulence.
            {' '}
            <button
              className="explainer-link"
              onClick={(e) => { e.stopPropagation(); navigate('/how-it-works'); }}
            >
              Learn more
            </button>
          </p>
        </div>
      )}
    </div>
  );
};

export default ScoringExplainer;
